// Germany border coordinates — 671 points from Natural Earth 10m admin-0
// Source: https://raw.githubusercontent.com/nvkelso/natural-earth-vector/master/geojson/ne_10m_admin_0_countries.geojson
// Generated by: scripts/generate-germany-border.mjs (Douglas-Peucker, epsilon=1.18e-2)
// Mainland polygon only (largest outer ring; offshore islands dropped).
export const GERMANY_COORDS: [number, number][] = [
  [13.8157, 48.7664],
  [13.7836, 48.7153],
  [13.8169, 48.6956],
  [13.8009, 48.6752],
  [13.8024, 48.6117],
  [13.7743, 48.5692],
  [13.7339, 48.5598],
  [13.7165, 48.5217],
  [13.6244, 48.5654],
  [13.5207, 48.5846],
  [13.4546, 48.5734],
  [13.4401, 48.561],
  [13.4592, 48.5164],
  [13.4056, 48.3766],
  [13.2742, 48.3071],
  [13.0328, 48.2636],
  [12.933, 48.2093],
  [12.8626, 48.1966],
  [12.7389, 48.1134],
  [12.7602, 48.0649],
  [12.8306, 48.0155],
  [12.862, 47.9626],
  [12.9311, 47.9249],
  [12.9912, 47.8471],
  [12.892, 47.7235],
  [12.964, 47.7054],
  [13.0199, 47.7129],
  [13.072, 47.6595],
  [13.072, 47.6224],
  [13.0281, 47.5416],
  [13.0373, 47.493],
  [13.0019, 47.466],
  [12.9316, 47.4735],
  [12.7789, 47.5548],
  [12.7859, 47.6027],
  [12.8132, 47.6118],
  [12.7517, 47.6494],
  [12.762, 47.6669],
  [12.6531, 47.6751],
  [12.4966, 47.6289],
  [12.4447, 47.6563],
  [12.4241, 47.6916],
  [12.2387, 47.6789],
  [12.2233, 47.6959],
  [12.2422, 47.732],
  [12.1766, 47.7058],
  [12.2068, 47.6456],
  [12.1736, 47.6051],
  [11.9359, 47.6107],
  [11.852, 47.5992],
  [11.8203, 47.5753],
  [11.6205, 47.5897],
  [11.5512, 47.5137],
  [11.4126, 47.5061],
  [11.3655, 47.4693],
  [11.3886, 47.4622],
  [11.3839, 47.4449],
  [11.3056, 47.4354],
  [11.237, 47.394],
  [11.213, 47.3958],
  [11.2152, 47.423],
  [11.1938, 47.4289],
  [11.0837, 47.3895],
  [10.9795, 47.3905],
  [10.9553, 47.4096],
  [10.9598, 47.4325],
  [10.8584, 47.4852],
  [10.8922, 47.5149],
  [10.8586, 47.5307],
  [10.7608, 47.5136],
  [10.5837, 47.5625],
  [10.5369, 47.5299],
  [10.4825, 47.5329],
  [10.4535, 47.5462],
  [10.4571, 47.5792],
  [10.4292, 47.577],
  [10.4142, 47.573],
  [10.431, 47.5422],
  [10.4196, 47.493],
  [10.4476, 47.4726],
  [10.452, 47.4388],
  [10.4283, 47.396],
  [10.3059, 47.3022],
  [10.1599, 47.2711],
  [10.1908, 47.2983],
  [10.2093, 47.3725],
  [10.0829, 47.3591],
  [10.0532, 47.4049],
  [10.076, 47.4169],
  [10.0718, 47.4391],
  [10.0226, 47.488],
  [9.9826, 47.481],
  [9.9459, 47.5408],
  [9.8335, 47.5346],
  [9.7821, 47.5884],
  [9.7527, 47.5821],
  [9.704, 47.5314],
  [9.6126, 47.5219],
  [9.1834, 47.6704],
  [9.0166, 47.6789],
  [8.9454, 47.6543],
  [8.8817, 47.6561],
  [8.8378, 47.6808],
  [8.8561, 47.6907],
  [8.7976, 47.72],
  [8.7707, 47.7209],
  [8.7699, 47.6951],
  [8.7171, 47.6946],
  [8.7004, 47.7235],
  [8.7131, 47.7574],
  [8.6819, 47.7587],
  [8.6441, 47.791],
  [8.6174, 47.7573],
  [8.6016, 47.7946],
  [8.5582, 47.8012],
  [8.5423, 47.795],
  [8.5516, 47.7793],
  [8.4636, 47.7639],
  [8.4379, 47.7232],
  [8.3921, 47.6995],
  [8.3913, 47.6655],
  [8.4583, 47.6399],
  [8.6073, 47.6563],
  [8.6016, 47.6326],
  [8.5803, 47.639],
  [8.5741, 47.5924],
  [8.5224, 47.6219],
  [8.4618, 47.6061],
  [8.4489, 47.5843],
  [8.3541, 47.581],
  [8.3063, 47.5922],
  [8.2886, 47.6158],
  [8.233, 47.622],
  [8.0423, 47.5606],
  [7.9122, 47.5606],
  [7.8982, 47.5878],
  [7.8197, 47.5953],
  [7.7667, 47.556],
  [7.6834, 47.5443],
  [7.6097, 47.5647],
  [7.6359, 47.5646],
  [7.6597, 47.5966],
  [7.586, 47.5846],
  [7.5903, 47.6079],
  [7.5179, 47.675],
  [7.5119, 47.7073],
  [7.5378, 47.7318],
  [7.5259, 47.7832],
  [7.562, 47.8392],
  [7.559, 47.8827],
  [7.5849, 47.9404],
  [7.6211, 47.9714],
  [7.6189, 48.0027],
  [7.5757, 48.0537],
  [7.5789, 48.1145],
  [7.6134, 48.1792],
  [7.6872, 48.2529],
  [7.7025, 48.3112],
  [7.7507, 48.3414],
  [7.7383, 48.4066],
  [7.7765, 48.4982],
  [7.8135, 48.5195],
  [7.8103, 48.615],
  [7.9592, 48.7214],
  [7.9701, 48.7573],
  [8.0173, 48.7618],
  [8.0388, 48.7908],
  [8.0903, 48.8075],
  [8.2003, 48.9586],
  [7.9319, 49.0348],
  [7.635, 49.0378],
  [7.6086, 49.062],
  [7.5209, 49.0837],
  [7.471, 49.1283],
  [7.4761, 49.1515],
  [7.4105, 49.1689],
  [7.351, 49.1592],
  [7.2744, 49.105],
  [7.155, 49.1144],
  [7.0799, 49.142],
  [7.0425, 49.1076],
  [7.0205, 49.119],
  [7.0095, 49.1817],
  [6.9144, 49.2067],
  [6.8335, 49.2095],
  [6.839, 49.1628],
  [6.8218, 49.1478],
  [6.7256, 49.1556],
  [6.701, 49.1729],
  [6.7025, 49.2136],
  [6.6806, 49.2075],
  [6.6397, 49.2712],
  [6.5564, 49.3264],
  [6.5556, 49.3472],
  [6.5777, 49.3558],
  [6.5117, 49.4247],
  [6.4027, 49.4655],
  [6.3453, 49.4553],
  [6.3508, 49.5666],
  [6.4179, 49.6391],
  [6.4027, 49.6558],
  [6.4997, 49.7122],
  [6.4855, 49.7338],
  [6.5026, 49.7957],
  [6.3026, 49.8349],
  [6.2868, 49.861],
  [6.2227, 49.8871],
  [6.1727, 49.9562],
  [6.1619, 49.9425],
  [6.0964, 50.0486],
  [6.1295, 50.134],
  [6.1213, 50.1616],
  [6.1651, 50.1819],
  [6.1468, 50.214],
  [6.2718, 50.2674],
  [6.286, 50.3039],
  [6.3745, 50.3155],
  [6.3377, 50.3681],
  [6.3512, 50.4336],
  [6.3233, 50.466],
  [6.3369, 50.481],
  [6.2072, 50.4863],
  [6.1708, 50.518],
  [6.1607, 50.5436],
  [6.2491, 50.6144],
  [6.1594, 50.6224],
  [6.1478, 50.6368],
  [6.1611, 50.6422],
  [6.081, 50.7135],
  [6.0116, 50.7085],
  [6.0108, 50.7371],
  [5.973, 50.7818],
  [6.0093, 50.8405],
  [6.0567, 50.8527],
  [6.0637, 50.9075],
  [5.9999, 50.9294],
  [6.0037, 50.9737],
  [5.8746, 50.9654],
  [5.8582, 51.0193],
  [5.8525, 51.0428],
  [5.8805, 51.0521],
  [5.938, 51.0309],
  [5.9829, 51.0747],
  [6.1473, 51.1523],
  [6.1263, 51.1646],
  [6.1571, 51.1793],
  [6.1341, 51.1842],
  [6.0843, 51.1627],
  [6.0608, 51.1709],
  [6.0566, 51.2117],
  [6.1478, 51.3182],
  [6.1936, 51.3445],
  [6.2078, 51.3877],
  [6.1927, 51.399],
  [6.2053, 51.4584],
  [6.1933, 51.5093],
  [6.0865, 51.5955],
  [6.0992, 51.6445],
  [6.0086, 51.6812],
  [6.0121, 51.7159],
  [5.9393, 51.7319],
  [5.9641, 51.7766],
  [5.9315, 51.8157],
  [6.084, 51.8537],
  [6.1561, 51.8421],
  [6.093, 51.8853],
  [6.127, 51.8967],
  [6.2252, 51.8625],
  [6.2647, 51.8662],
  [6.342, 51.8367],
  [6.345, 51.8211],
  [6.3825, 51.8276],
  [6.3785, 51.8601],
  [6.4629, 51.8484],
  [6.5286, 51.8764],
  [6.7438, 51.9083],
  [6.8107, 51.9606],
  [6.8092, 51.9795],
  [6.675, 52.0348],
  [6.6799, 52.0605],
  [6.7499, 52.1029],
  [6.8307, 52.1129],
  [6.8848, 52.1603],
  [7.0263, 52.2306],
  [7.0125, 52.2849],
  [7.0482, 52.3651],
  [6.9733, 52.4514],
  [6.9002, 52.4319],
  [6.7148, 52.4616],
  [6.6717, 52.5417],
  [6.7438, 52.5597],
  [6.704, 52.5831],
  [6.7018, 52.6191],
  [6.737, 52.6347],
  [7.0185, 52.626],
  [7.0367, 52.6474],
  [7.062, 52.824],
  [7.1619, 52.9326],
  [7.1928, 52.998],
  [7.1719, 53.1377],
  [7.1954, 53.185],
  [7.1946, 53.245],
  [7.2336, 53.2736],
  [7.2295, 53.2966],
  [7.2547, 53.3195],
  [7.3665, 53.3028],
  [7.3029, 53.3328],
  [7.0752, 53.3376],
  [7.0383, 53.3486],
  [7.0236, 53.3764],
  [7.0233, 53.4505],
  [7.0514, 53.5126],
  [7.1196, 53.5163],
  [7.1418, 53.5372],
  [7.0868, 53.5869],
  [7.2261, 53.6665],
  [7.305, 53.6848],
  [7.4588, 53.6951],
  [7.5039, 53.6787],
  [7.9514, 53.7219],
  [8.0314, 53.7081],
  [8.0249, 53.6726],
  [8.0529, 53.6363],
  [8.1276, 53.5908],
  [8.1192, 53.5719],
  [8.168, 53.5532],
  [8.1554, 53.526],
  [8.0588, 53.502],
  [8.077, 53.4687],
  [8.0998, 53.4474],
  [8.1524, 53.4498],
  [8.2053, 53.4107],
  [8.2595, 53.4123],
  [8.3151, 53.4749],
  [8.3205, 53.5092],
  [8.2915, 53.5294],
  [8.2312, 53.5252],
  [8.2707, 53.6129],
  [8.3294, 53.6181],
  [8.3877, 53.5771],
  [8.5521, 53.5436],
  [8.49, 53.4864],
  [8.485, 53.4012],
  [8.5044, 53.3581],
  [8.4976, 53.4748],
  [8.5567, 53.5182],
  [8.5658, 53.5467],
  [8.5083, 53.6251],
  [8.4861, 53.7004],
  [8.5876, 53.8704],
  [8.6727, 53.8916],
  [8.7446, 53.8542],
  [8.8607, 53.831],
  [9.2107, 53.872],
  [9.2834, 53.8616],
  [9.5824, 53.5913],
  [9.6966, 53.5566],
  [9.832, 53.5436],
  [9.7821, 53.5697],
  [9.6924, 53.5759],
  [9.5837, 53.6125],
  [9.5508, 53.6346],
  [9.5322, 53.7112],
  [9.4358, 53.7487],
  [9.3952, 53.831],
  [9.2578, 53.8856],
  [9.03, 53.9071],
  [8.9846, 53.897],
  [8.916, 53.9374],
  [8.8333, 54.0364],
  [8.8906, 54.0478],
  [8.9972, 54.0302],
  [9.0183, 54.0979],
  [8.9529, 54.1501],
  [8.8607, 54.1252],
  [8.8128, 54.1805],
  [8.8467, 54.2335],
  [8.8396, 54.2556],
  [8.922, 54.2742],
  [8.9631, 54.3176],
  [8.8811, 54.2903],
  [8.888, 54.3039],
  [8.7389, 54.2939],
  [8.6785, 54.2692],
  [8.6234, 54.2901],
  [8.5999, 54.3381],
  [8.6956, 54.3586],
  [8.6506, 54.378],
  [8.6348, 54.3654],
  [8.6292, 54.3877],
  [8.6484, 54.4064],
  [8.8861, 54.4178],
  [9.0047, 54.4659],
  [9.0116, 54.5063],
  [8.8788, 54.6065],
  [8.8259, 54.5981],
  [8.8533, 54.6193],
  [8.8054, 54.6876],
  [8.6887, 54.7353],
  [8.6943, 54.7602],
  [8.6428, 54.8442],
  [8.6608, 54.8963],
  [8.9041, 54.8979],
  [9.1948, 54.8504],
  [9.2441, 54.8018],
  [9.4514, 54.8104],
  [9.5799, 54.8663],
  [9.5832, 54.8303],
  [9.7346, 54.8073],
  [9.8018, 54.7834],
  [9.8237, 54.7567],
  [9.8954, 54.7695],
  [9.8914, 54.7903],
  [9.9475, 54.7795],
  [10.0182, 54.7012],
  [9.9705, 54.7012],
  [9.9295, 54.6739],
  [10.0391, 54.6668],
  [10.0269, 54.56],
  [9.9656, 54.5062],
  [9.8401, 54.4753],
  [9.8833, 54.4621],
  [10.1434, 54.4918],
  [10.2039, 54.461],
  [10.1839, 54.4494],
  [10.1913, 54.3967],
  [10.1418, 54.3723],
  [10.1555, 54.3434],
  [10.1418, 54.3244],
  [10.1803, 54.3411],
  [10.2244, 54.4138],
  [10.3184, 54.4433],
  [10.6011, 54.3654],
  [10.7313, 54.3102],
  [10.9353, 54.3795],
  [11.0188, 54.3859],
  [10.9758, 54.3784],
  [11.0339, 54.3676],
  [11.1042, 54.3929],
  [11.1355, 54.3859],
  [11.0877, 54.3518],
  [11.0666, 54.3586],
  [11.0945, 54.2835],
  [11.0902, 54.208],
  [11.0666, 54.1839],
  [10.8928, 54.1025],
  [10.8054, 54.0949],
  [10.7526, 54.0501],
  [10.7804, 54.01],
  [10.8755, 53.9954],
  [10.9021, 53.9614],
  [11.0535, 54.0085],
  [11.1751, 54.018],
  [11.2454, 53.9784],
  [11.2429, 53.9452],
  [11.2937, 53.9409],
  [11.3342, 53.9614],
  [11.4577, 53.9062],
  [11.4724, 53.9688],
  [11.4979, 53.9818],
  [11.4917, 54.0023],
  [11.5259, 54.0228],
  [11.5191, 54.0364],
  [11.5735, 54.039],
  [11.6245, 54.0836],
  [11.6253, 54.1098],
  [11.6897, 54.1552],
  [11.8123, 54.1498],
  [12.0881, 54.1941],
  [12.0916, 54.114],
  [12.115, 54.0979],
  [12.0951, 54.1457],
  [12.1428, 54.1805],
  [12.1089, 54.183],
  [12.1869, 54.2434],
  [12.3421, 54.3039],
  [12.5339, 54.4883],
  [12.5483, 54.4621],
  [12.5915, 54.4517],
  [12.8796, 54.4488],
  [12.9212, 54.4335],
  [12.8708, 54.4168],
  [12.6946, 54.4337],
  [12.6242, 54.4229],
  [12.5817, 54.4064],
  [12.5947, 54.3859],
  [12.554, 54.3908],
  [12.527, 54.3723],
  [12.4385, 54.3875],
  [12.424, 54.3449],
  [12.3967, 54.3518],
  [12.3916, 54.3211],
  [12.3626, 54.3102],
  [12.3801, 54.2771],
  [12.3688, 54.2692],
  [12.4124, 54.2514],
  [12.4582, 54.2556],
  [12.4103, 54.2692],
  [12.4168, 54.281],
  [12.4724, 54.3102],
  [12.4787, 54.3319],
  [12.5606, 54.3586],
  [12.5408, 54.3723],
  [12.6227, 54.3739],
  [12.7048, 54.4146],
  [12.7175, 54.4064],
  [12.6841, 54.3723],
  [12.7046, 54.3996],
  [12.735, 54.3782],
  [12.7871, 54.3921],
  [12.818, 54.358],
  [12.8547, 54.3579],
  [12.9294, 54.4144],
  [13.0088, 54.4381],
  [13.0342, 54.4337],
  [13.021, 54.4145],
  [13.0404, 54.3921],
  [13.0956, 54.3723],
  [13.0767, 54.3525],
  [13.1149, 54.28],
  [13.2888, 54.2343],
  [13.3489, 54.1805],
  [13.3215, 54.1668],
  [13.4035, 54.1737],
  [13.383, 54.1531],
  [13.4177, 54.1531],
  [13.4836, 54.0913],
  [13.5071, 54.0979],
  [13.4793, 54.1252],
  [13.7119, 54.1737],
  [13.6983, 54.1531],
  [13.8081, 54.1047],
  [13.7732, 54.0463],
  [13.7461, 54.0364],
  [13.8386, 53.9863],
  [13.8486, 53.9556],
  [13.906, 53.9431],
  [13.8901, 53.9129],
  [13.8185, 53.878],
  [13.8171, 53.8529],
  [14.0374, 53.7553],
  [14.1865, 53.7398],
  [14.2341, 53.7618],
  [14.2645, 53.7516],
  [14.2595, 53.728],
  [14.2127, 53.7081],
  [14.2639, 53.7],
  [14.261, 53.6562],
  [14.297, 53.5978],
  [14.3042, 53.5085],
  [14.3599, 53.4441],
  [14.4033, 53.2788],
  [14.4416, 53.2518],
  [14.3807, 53.1899],
  [14.3895, 53.1317],
  [14.3433, 53.0486],
  [14.1445, 52.9599],
  [14.165, 52.8957],
  [14.1239, 52.8507],
  [14.3822, 52.7382],
  [14.4319, 52.6861],
  [14.6448, 52.5769],
  [14.6091, 52.5178],
  [14.6323, 52.4967],
  [14.5398, 52.4219],
  [14.5454, 52.3822],
  [14.5901, 52.3094],
  [14.5842, 52.2912],
  [14.7124, 52.2359],
  [14.6864, 52.121],
  [14.7614, 52.0767],
  [14.6991, 51.9925],
  [14.6871, 51.9119],
  [14.5959, 51.8424],
  [14.5858, 51.8039],
  [14.6342, 51.769],
  [14.6484, 51.7172],
  [14.7325, 51.6583],
  [14.7439, 51.6066],
  [14.7127, 51.5674],
  [14.71, 51.5302],
  [14.911, 51.469],
  [14.9554, 51.4354],
  [14.961, 51.3353],
  [15.0195, 51.2717],
  [15.0221, 51.2368],
  [14.9553, 51.064],
  [14.8602, 50.9168],
  [14.8105, 50.8771],
  [14.7946, 50.8316],
  [14.7592, 50.8102],
  [14.6132, 50.8456],
  [14.6292, 50.9207],
  [14.5504, 50.9121],
  [14.5743, 50.9755],
  [14.5029, 51.0085],
  [14.4821, 51.0372],
  [14.3978, 51.0131],
  [14.2875, 51.0368],
  [14.2383, 50.9825],
  [14.3038, 50.9697],
  [14.2928, 50.9535],
  [14.3183, 50.9375],
  [14.3819, 50.9209],
  [14.3465, 50.8802],
  [14.2321, 50.8794],
  [14.1908, 50.8479],
  [14.0349, 50.8026],
  [13.9596, 50.8021],
  [13.8925, 50.7804],
  [13.8822, 50.7427],
  [13.8345, 50.7237],
  [13.5566, 50.7067],
  [13.5156, 50.691],
  [13.5233, 50.6622],
  [13.4479, 50.5973],
  [13.3688, 50.6283],
  [13.3056, 50.5758],
  [13.2323, 50.582],
  [13.1601, 50.497],
  [13.0096, 50.4927],
  [12.9966, 50.4337],
  [12.9526, 50.4042],
  [12.8174, 50.443],
  [12.7379, 50.4315],
  [12.6918, 50.3947],
  [12.5102, 50.3888],
  [12.3365, 50.2586],
  [12.3004, 50.1608],
  [12.2299, 50.2348],
  [12.2396, 50.2566],
  [12.178, 50.2688],
  [12.1493, 50.3117],
  [12.0761, 50.3152],
  [12.111, 50.2766],
  [12.0796, 50.2427],
  [12.1751, 50.1826],
  [12.1792, 50.118],
  [12.2325, 50.0805],
  [12.2469, 50.045],
  [12.4513, 49.9806],
  [12.4682, 49.9702],
  [12.4627, 49.9313],
  [12.5241, 49.905],
  [12.4825, 49.8272],
  [12.4625, 49.8312],
  [12.4527, 49.7797],
  [12.3836, 49.7429],
  [12.4196, 49.7002],
  [12.4964, 49.67],
  [12.502, 49.6197],
  [12.5466, 49.5956],
  [12.5829, 49.5224],
  [12.623, 49.5098],
  [12.6435, 49.4295],
  [12.7293, 49.3911],
  [12.7779, 49.3325],
  [12.8567, 49.3222],
  [12.8847, 49.3396],
  [12.9998, 49.2949],
  [13.1785, 49.1183],
  [13.2995, 49.0936],
  [13.3724, 49.0385],
  [13.3985, 48.9777],
  [13.4589, 48.945],
  [13.4823, 48.9376],
  [13.516, 48.9702],
  [13.6087, 48.9462],
  [13.6374, 48.8935],
  [13.7247, 48.8673],
  [13.8157, 48.7664],
]

// Context-label cities for the German locations map. Mirrors the Swiss
// MAJOR_CITIES list in components/ui/location-map.tsx but with German cities,
// so the /de/de map doesn't draw Swiss labels (Basel, Schaffhausen, …) that
// overlap the bottom-pinned legend. Northern/central bias keeps labels clear
// of the legend; München is the southernmost and still sits well above the
// fitted southern edge.
export const GERMANY_MAJOR_CITIES: Array<{
  name: string
  lat: number
  lng: number
  dy?: number
  dx?: number
}> = [
  { name: "Berlin", lat: 52.52, lng: 13.405 },
  { name: "Hamburg", lat: 53.5511, lng: 9.9937 },
  { name: "Köln", lat: 50.9375, lng: 6.9603, dy: -4 },
  { name: "Frankfurt", lat: 50.1109, lng: 8.6821 },
  { name: "Stuttgart", lat: 48.7758, lng: 9.1829, dy: -4 },
  { name: "München", lat: 48.1351, lng: 11.582 },
  { name: "Düsseldorf", lat: 51.2277, lng: 6.7735, dy: -4 },
]
